export const initialState = {
  currencies: ['ARS', 'USD'],
  limits: {
    payment: {
      withdrawal: {
        min: 0,
        max: 0,
      },
      top_up: {
        min: 0,
        max: 0,
      },
    },
    bets: {
      default: 0,
      min: 0,
      max: 0,
    },
    bonus: {
      max_bonus_percent: 0,
      min_coef: 0,
      cashback_payment: 0,
      cashback_bet: 0,
      max_bet_count: 0,
      registration_bonus: 0,
      max_bonus_size: 0,
    },
  },
  INBET_KF: {
    ARS: 0,
  },
  password_settings: {
    player: {
      active: true,
      min_length: 0,
      digits: {
        amount: 0,
      },
      letters: {
        amount: 0,
        uppercase: 0,
        lowercase: 0,
      },
      special_characters: {
        amount: 0,
      },
    },
    agent: {
      active: true,
      min_length: 0,
      digits: {
        amount: 0,
      },
      letters: {
        amount: 0,
        uppercase: 0,
        lowercase: 0,
      },
      special_characters: {
        amount: 0,
      },
    },
  },
  deposit_level_settings: {
    bronze: {
      from: -1,
      to: -1,
    },
    silver: {
      from: -1,
      to: -1,
    },
    gold: {
      from: -1,
      to: -1,
    },
    black: {
      from: -1,
      to: -1,
    },
  },
  social_network_settings: {
    telegram: '',
  },
};
